"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";

// Reimplements @next/third-parties' <GoogleTagManager> but loads the gtm.js
// payload with strategy="lazyOnload" instead of "afterInteractive". GTM's
// own evaluate cycles were showing up as ~30ms of main-thread blocking during
// initial load; deferring the fetch/exec to idle time keeps the dataLayer
// queueing working exactly the same (events pushed before gtm.js loads are
// processed once it does) while getting it off the critical path.
export default function GoogleTagManagerLazy(t0) {
  const $ = _c(3);
  const {
    gtmId
  } = t0;
  if (!gtmId) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Script id="_next-gtm-init" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: "\n      (function(w,l){\n        w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});\n      })(window,'dataLayer');"
    }} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  let t3;
  if ($[1] !== t2) {
    t3 = <>{t1}<Script id="_next-gtm" strategy="lazyOnload" src={t2} /></>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}